import { RotateCcw } from 'lucide-react';

type Props = {
  onClick: () => void;
  testId: string;
};

export const ResetButton = ({ onClick, testId }: Props) => (
  <button
    type="button"
    data-testid={testId}
    onClick={onClick}
    className="flex size-8 cursor-pointer items-center justify-center rounded-md text-foreground-subtle transition hover:bg-accent hover:text-foreground"
    aria-label="Reset to default"
  >
    <RotateCcw className="size-4" />
  </button>
);
